import { twMerge } from 'tailwind-merge'

export function CircularProgress({ className }: { className?: string }) {
  return (
    <svg
      className={twMerge('animate-spin text-white', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  )
}

export function FancyCircularProgress({ className }: { className?: string }) {
  return (
    <svg className={twMerge('aspect-square', className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <ellipse
        className="animate-[spin_1.6s_linear_infinite] origin-center"
        cx="40"
        rx="38"
        ry="38"
        cy="40"
        fill="none"
        stroke="currentColor"
        strokeWidth="4px"
        strokeDasharray={`119.3 ${Array.from({ length: 30 })
          .map(() => '3.85')
          .join(' ')}`}
      />

      <ellipse
        className="animate-[spin-reverse_1.5s_linear_infinite] origin-center"
        cx="40"
        rx="24"
        ry="24"
        cy="40"
        fill="none"
        stroke="currentColor"
        strokeWidth="4px"
        strokeDasharray="4.1 4.1 4.1 4.1 4.1 4.1 4.1 4.1 114"
      />
    </svg>
  )
}
